<template>
    <card-sections
        :title="Lang.get('employerdashboard::pages/settings/two-factor-authentication.title')"
        :subtitle="Lang.get('employerdashboard::pages/settings/two-factor-authentication.subtitle')"
        tabName="two-factor-authentication"
        :hideMsg="true"
    >
        <p class="font-poppins font-weight-light color-dark-blue">
            {{ Lang.get('employerdashboard::pages/settings/two-factor-authentication.explanation') }}
        </p>

        <template v-if="isEnabled">
            <div class="alert alert-success">
                {{ Lang.get('employerdashboard::pages/settings/two-factor-authentication.success.body') }}
            </div>
            <div class="d-flex justify-content-between align-items-center">
                <inertia-link as="a"
                    :href="route('nl.employerdashboard.settings.two-factor-authentication.regerenerate-recovery-codes.password.show', {
                        company_as_uuid: $page.props.auth.user.selected_company.uuid
                    })"
                    class="font-poppins font-weight-light color-dark-blue"
                >
                    {{ Lang.get('employerdashboard::pages/settings/two-factor-authentication.start.regenerate_recovery_codes_button') }}
                </inertia-link>
                <inertia-link as="button"
                    :href="route('nl.employerdashboard.settings.two-factor-authentication.disable.index', {
                        company_as_uuid: $page.props.auth.user.selected_company.uuid
                    })"
                    class="btn btn-outline-danger"
                >
                    {{ Lang.get('employerdashboard::pages/settings/two-factor-authentication.start.disable_button') }}
                </inertia-link>
            </div>
        </template>

        <template v-else>
            <form @submit.prevent="submit()">
                <p class="font-poppins font-weight-light color-dark-blue">
                    {{ Lang.get('employerdashboard::pages/settings/two-factor-authentication.start.body') }}
                </p>
                <div class="row mb-4">
                    <div class="form-group col-12 col-md-4">
                        <text-input
                            v-model="form.password"
                            :label="Lang.get('employerdashboard::shared.placeholder.password')"
                            :placeholder="Lang.get('employerdashboard::shared.placeholder.password')"
                            :error="errors.password"
                            type="password"
                        />
                    </div>
                    <div class="col-12">
                        <a href="https://www.deleerrekening.nl/faq/77168641/2-factor-authentication-2fa-instellen"
                           target="_blank"
                        >
                            {{ Lang.get('employerdashboard::pages/settings/two-factor-authentication.faq_link') }}
                        </a>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12 col-md-4">
                        <button
                            type="submit"
                            :disabled="!canSubmit"
                            class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4">
                            {{ Lang.get('employerdashboard::pages/settings/two-factor-authentication.start.button') }}
                        </button>
                    </div>
                </div>
            </form>

        </template>
    </card-sections>
</template>

<script>
import CardSections from "@/Pages/Settings/Shared/CardSections";
import TextInput from "@/Shared/TextInput";

export default {
    components: {
        CardSections,
        TextInput,
    },
    props: {
        errors: Object,
        isEnabled: Boolean,
    },
    data() {
        return {
            form: this.$inertia.form({
                password: null,
            }),
        }
    },
    computed: {
        canSubmit() {
            return this.form.password?.length > 0 && !this.form.processing;
        },
    },
    methods: {
        submit() {
            this.form.post(
                this.route(
                    'nl.employerdashboard.settings.two-factor-authentication.start',
                    this.$page.props.auth.user.selected_company.uuid
                ),
            );
        },
    },
}
</script>

<style scoped>
button[disabled="disabled"] {
    pointer-events: none;
}

</style>
